import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { TenantMsGraphOptions } from 'app/api/models/tenant/TenantMsGraphOptions';
import { DataRoomService } from 'app/api/services/dataRoom.service';
import { TreeNode } from 'primeng/api/treenode';

@Component({
  selector: 'app-tenant-ms-graph-edit-form',
  templateUrl: './tenant-ms-graph-edit-form.component.html',
  styleUrls: ['./tenant-ms-graph-edit-form.component.scss'],
})
export class TenantMsGraphEditFormComponent {
  @Input() msGraphOptions: TenantMsGraphOptions | undefined;
  @Input() tenantId: string = '';
  @Output() optionsSubmit = new EventEmitter<TenantMsGraphOptions>();

  Form?: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private dataRoomService: DataRoomService,
  ) {}

  showDriveTree = false;
  drivesStruct: any[] = [];
  selectedDrive: any;
  folderNodes: TreeNode[] = [];
  selectedNode: TreeNode | null = null;
  ngOnInit() {
    this.setUpForm();

    setTimeout(() => {
      this.Form!.get('useSharePointForDataRoom')!.valueChanges.subscribe(
        (value: boolean) => {
          console.log(value);
          if (value) {
            this.getStructure();
            this.showDriveTree = true;
          } else {
            this.showDriveTree = false;
            ///
          }
        },
      );
    }, 3000);
  }

  onDriveChange(driveId: string) {
    this.applyDrive(driveId);
  }

  private applyDrive(driveId: string) {
    const drive = this.drivesStruct.find((x) => x.driveId === driveId);
    this.folderNodes = this.toTreeNodes(drive?.driveFolders ?? []);
    this.selectedNode = null;
  }

  private toTreeNodes(folders: any[]): TreeNode[] {
    return folders.map((f) => ({
      key: f.folderId,
      label: f.folderName,
      icon: 'pi pi-folder',
      expanded: true,
      children: this.toTreeNodes(f.driveFolderItems ?? []),
    }));
  }

  folderId: string = '';
  folderName: string = '';

  onFolderSelect(ev: any) {
    const folderId = ev.node?.key as string;
    const folderName = ev.node?.label as string;

    this.folderId = folderId;
    this.folderName = folderName;
    this.Form?.markAsDirty();
  }
  loading = false;
  getStructure() {
    this.loading = true;
    this.dataRoomService
      .getDrives({
        clientId: this.Form?.value.msGraphClientId,
        clientSecret: this.Form?.value.msGraphClientSecret,
        tenantId: this.Form?.value.msGraphTenantId,
      })
      .subscribe((x) => {
        this.drivesStruct = x.driveItems;

        let selectedFolderId = this.msGraphOptions?.startFolderId ?? null;

        const drive = this.findDriveByFolderId(selectedFolderId!);
        this.selectedDrive = drive?.driveId ?? null;

        this.folderNodes = this.toTreeNodes(drive?.driveFolders ?? []);
        this.selectedNode = this.findNodeByKey(
          this.folderNodes,
          selectedFolderId,
        );
        this.loading = false;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['msGraphOptions'] && !changes['msGraphOptions'].firstChange) {
      this.setUpForm();
    }
  }

  formResult() {
    if (this.Form && !this.Form.valid) {
      this.Form.markAllAsTouched();
      return;
    }

    var result = new TenantMsGraphOptions();
    result.msGraphClientId = this.Form?.value.msGraphClientId;
    result.msGraphClientSecret = this.Form?.value.msGraphClientSecret;
    result.msGraphFromMail = this.Form?.value.msGraphFromMail;
    result.msGraphTenantId = this.Form?.value.msGraphTenantId;
    result.tenantId = this.tenantId;
    result.startFolderId = this.folderId;
    result.startFolderName = this.folderName;
    result.driveId = this.selectedDrive;
    result.title = this.Form?.value.title;
    result.useForSystemMails = this.Form?.value.useForSystemMails;
    result.customBusinessCard = this.Form?.value.customBusinessCard;
    result.useSharePointForDataRoom = this.Form?.value.useSharePointForDataRoom;
    // result.startFolderPath = this.Form?.value.startFolderPath;
    result.customBusinessCardContent =
      this.Form?.value.customBusinessCardContent;

    if (this.msGraphOptions) {
      result.id = this.msGraphOptions.id;
    }

    this.optionsSubmit.emit(result);
  }

  setUpForm() {
    this.Form = this.formBuilder.group({
      title: [this.msGraphOptions?.title ?? '', Validators.required],
      msGraphClientId: [
        this.msGraphOptions?.msGraphClientId ?? '',
        Validators.required,
      ],
      msGraphClientSecret: [
        this.msGraphOptions?.msGraphClientSecret ?? '',
        Validators.required,
      ],
      msGraphFromMail: [
        this.msGraphOptions?.msGraphFromMail ?? '',
        Validators.required,
      ],
      msGraphTenantId: [
        this.msGraphOptions?.msGraphTenantId ?? '',
        Validators.required,
      ],
      //startFolderPath: [this.msGraphOptions?.startFolderPath ?? ''],
      useForSystemMails: [this.msGraphOptions?.useForSystemMails ?? false],

      customBusinessCard: [this.msGraphOptions?.customBusinessCard ?? false],
      useSharePointForDataRoom: [
        this.msGraphOptions?.useSharePointForDataRoom ?? false,
      ],
      customBusinessCardContent: [
        this.msGraphOptions?.customBusinessCardContent ?? '',
      ],
    });

    if (this.msGraphOptions?.useSharePointForDataRoom ?? false) {
      this.showDriveTree = true;

      this.getStructure();
    }
  }

  findDriveByFolderId(folderId: string): any | null {
    for (const drive of this.drivesStruct) {
      if (this.containsFolder(drive.driveFolders ?? [], folderId)) {
        return drive;
      }
    }
    return null;
  }

  private containsFolder(folders: any[], folderId: string): boolean {
    for (const f of folders) {
      if (f.folderId === folderId) {
        return true;
      }
      if (this.containsFolder(f.driveFolderItems ?? [], folderId)) {
        return true;
      }
    }
    return false;
  }

  private findNodeByKey(
    nodes: TreeNode[],
    key: string | null,
  ): TreeNode | null {
    if (!key) return null;
    for (const n of nodes) {
      if (n.key === key) return n;
      const found = this.findNodeByKey(n.children ?? [], key);
      if (found) return found;
    }
    return null;
  }

  cancel() {
    this.router.navigate([`tenants/emails/${this.tenantId}`]);
  }
}
